import styled from 'styled-components'

export const Container = styled.div<{ heightFixed?: boolean }>`
  display: flex;
  flex-direction: column;
  ${(props) => (props.heightFixed ? 'height: 100%;' : '')}
  min-height: 100%;
  flex: 1;
  overflow: hidden;
`
